import { useSelector } from 'react-redux'
import { selectAllCustomFieldsSettings } from '@user/store/customFieldSettings'

export function useCustomFieldsVisible() {
  const customSettings = useSelector(selectAllCustomFieldsSettings)

  return {
    hasEnabledCustomFields: customSettings.some((x) => x.enabled) ?? false,
    hasRequiredCustomFields: customSettings.some((x) => x.required) ?? false,
  }
}
